export class WalletHistory {
    public id!: number;
    public uId!: number;
    public userName!: string;
    public mainOrderId!: number;
    public amount!: number;
    public hContent!: string;
    public moneyLeft!: number;
    public type!: number;
    public tradeType!: number;
    public tradeTypeDetail!: any;
    public createDate!: string;
    public createBy!: string;
    public userRecharge!: any;
    public rechargeId!: number;
    public orderType!: number;
}

